// SB Custom Product

// document.addEventListener("DOMContentLoaded", function () {
//   const interval = setInterval(function () {
//     const customizeBtn = document.querySelector('.setubridgeProductDesigner');
//     const wishlistBar = document.querySelector('.swym-wishlist-button-bar');

//     if (customizeBtn && wishlistBar) {
//       wishlistBar.appendChild(customizeBtn);
//       clearInterval(interval);
//     }
//   }, 300);
// });

// ************************************************************


// Zepto

function moveButtonAboveWishlist() {
  const container = document.querySelector(".product-personalizer");
  const wishlistBar = document.querySelector(".swym-wishlist-button-bar");

  if (container && wishlistBar) {
    // This moves the personalizer container to sit exactly above the wishlist bar
    wishlistBar.parentNode.insertBefore(container, wishlistBar);
    
    // Add a little spacing so they don't touch
    container.style.marginBottom = "10px";
    container.style.display = "block";
  }
}

// Run it immediately
moveButtonAboveWishlist();

// Add it to your variant change function to ensure it stays there
// moveButtonAboveWishlist();

